export default "__VITE_ASSET__Dd2zo2n7__"